import React, { useEffect } from 'react';
import { inject, observer } from 'mobx-react';
import Header from './Header';
import Table from './Table';
import Pagination from './Pagination';

export default inject('root')(
  observer(({ root }) => {
    const { shippingModes, loadShippingModes, loading, pagination } = root.shippingModes;

    useEffect(() => {
      loadShippingModes();
    }, []);

    return (
      <>
        <Header />
        <Table
          loading={loading}
          shippingModes={shippingModes}
        />
         <Pagination pagination={pagination} />
      </>
    );
  })
)
